jQuery(document).ready(function ($) {
  var $box_carousel_products = $(".box-carousel.carousel-products .swiper");

  if (!$box_carousel_products.length) return;

  $box_carousel_products.each(function (index, element) {
    var mySwiper = new Swiper(element, {
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      slidesPerView: 2,
      spaceBetween: 15,
      speed: 400,
      navigation: {
        nextEl: $(element).parent().find(".carousel-navigation.next")[0],
        prevEl: $(element).parent().find(".carousel-navigation.prev")[0],
      },
      breakpoints: {
        576: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
  });
});
